/**
 * Global Imports
*/

import PropTypes from 'prop-types';
import React, { useContext, useState, useEffect } from 'react';

/**
 * Root Imports
*/
import { Message } from '~/components/Widget/';
import { DisplayToggle } from '~/components/Widget';
import { GuestContext } from '~/components/Authenticator';
import {
  LoginService,
  RegisterService,
  ForgotPasswordService } from '~/services/Auth';

/**
 * Local Imports
*/

import { Login, Register, ForgotPassword } from './';
import { LayoutContext } from '../Layouts/Guest';

/**
 * Exports
*/

export const AuthContext = React.createContext({
  errors: {}
});

/**
 * 
 */
export function GuestForms(props) {
  /** Contexts **/

  const layout = useContext(LayoutContext);
  const guest = useContext(GuestContext);
  
  /** States **/

  const [ error, setError ] = useState({});
  const [ success, setSuccess ] = useState({});
  
  /** Side-Effects **/

  useEffect(() => {
    setError({});
    setSuccess({});
  }, [ props.mode ]);

  /** Event Handlers **/

  /**
   * 
   */
  const handleAuthSuccess = (response) => {
    guest.authenticate(response.data);
  };

  /**
   * 
   */
  const handleError = (setSubmitting, error) => {
    layout.setIsBusy(false);
    setSubmitting(false);
    setError({
      ...error.response.data,
      fields: Object.keys( error.response.data.errors || {} )
    });
  };

  /**
   * 
   */
  const handleLogin = (values, { setSubmitting }) => {
    layout.setIsBusy(true);

    LoginService(values)
      .then(handleAuthSuccess)
      .catch(handleError.bind(this, setSubmitting))
    ;
  };

  /**
   * 
   */
  const handleRegister = (values, { setSubmitting }) => {
    layout.setIsBusy(true);

    RegisterService(values)
      .then(handleAuthSuccess)
      .catch(handleError.bind(this, setSubmitting))
    ;
  };

  /**
   * 
   */
  const handleForgotPassword = (values, { setSubmitting }) => {
    layout.setIsBusy(true);

    ForgotPasswordService(values)
      .then(response => {
        setSuccess(response.data.message);
        setSubmitting(false);
        layout.setIsBusy(false);
      })
      .catch(handleError.bind(this, setSubmitting))
    ;
  };

  /** Renderers **/

  /**
   * 
   */
  const renderErrorMessages = () => {
    const message = error.message;
    const errors = Object.entries(error.errors || {});

    if (!message) {
      return null;
    }

    return (
      <Message className='msg-error mb-4' onClose={ () => setError({}) }>
      {
        !errors.length ? <p>{ message }</p> :
          errors.map(([ field, messages ]) => (
            messages.map((message, index) => (
              <p key={ index }>{ message }</p>
            ))
          ))
      }
      </Message>
    );
  };

  /** **/

  /**
   * 
   */
  const buildContextHandlers = () => ({
    onLogin: handleLogin,
    onRegister: handleRegister,
    onResetPassword: null,
    onForgotPassword: handleForgotPassword
  });

  /** Output **/

  return (
    <AuthContext.Provider value={{ errorFields : error.fields || [], ...buildContextHandlers() }}>
      {
        success.message &&
          <Message className='msg-success mb-4' onClose={ () => setSuccess(null) }>
            <p>{ success.message }</p>
          </Message>
      }

      { renderErrorMessages() }

      <DisplayToggle
        activeMode={ props.mode }
        defaultMode='Login'
        modes={{ Login, Register, ForgotPassword }}
      />
    </AuthContext.Provider>
  );
}